import { createContext, useReducer } from 'react'
import { type LogProviderProps, type LogDataContextProps, type LogDispatchContextProps, type Log } from 'src/types'

import { reducer } from './reducer'

const defaultLogs: Log[] = []

export const LogDataContext = createContext<LogDataContextProps>({ logs: defaultLogs })
LogDataContext.displayName = 'LogDataContext'

export const LogDispatchContext = createContext<LogDispatchContextProps>({ dispatchLogs: () => null })
LogDispatchContext.displayName = 'LogDispatchContext'

export const LogProvider = ({ children }: LogProviderProps) => {
  const [logs, dispatchLogs] = useReducer(reducer, defaultLogs)
  
  return (
    <LogDataContext.Provider value={{ logs }}>
      <LogDispatchContext.Provider value={{ dispatchLogs }}>
        {children}
      </LogDispatchContext.Provider>
    </LogDataContext.Provider>
  )
}
